'use strict';

/**
 * Объект закладки "Карточка" в карточке объекта.
 *
 * @class WebAccess.components.CardTabMainTab
 *
 * @property {number} type Тип закладки карточки.
 * @property {object} content Модель HTML-содержимого закладки "Карточка".
 * @property {string} content.main HTML-содержимое контейнера с формой карточки и областью переписки.
 * @property {string} content.aside HTML-содержимое контейнера с областью вложений.
 * @property {bool} contentJustReceivedFromServer Признак того, что данные только что получены с сервера. Позволяет определить необходимость инициализации скриптов.
 * @property {string} serializedTabData Сериализованные поля формы и область вложений карточки. Позволяют проверить, есть ли пользовательский ввод и нужно ли предупреждать о потере пользовательских данных при закрытии закладки.
 * @property {object} scriptsEvalAfterRender Скрипты, которые вызываются после генерации React-компоненты.
 * @property {array} scriptsEvalAfterRender.pending Массив со скриптами, ожидающими выполнения. //TODO: переделать массивы со скриптами на ES6-коллекцию new Set()
 * @property {array} scriptsEvalAfterRender.evaluated Массив с уже выполненными скриптами.
 * @property {array} scriptsAlwaysEvalAfterRender Массив со скриптами, которые вызываются каждый раз при обновлении модели после генерации React-компоненты.
 * @since 5.6.0
 */

// На закладке карточки каждый скрипт, приходящий с разметкой с сервера, должен вызываться только один раз во избежание многократных биндов и перерендеров.
// Сначала скрипты попадают в scriptsEvalAfterRender.pending, после завершения рендера они вызываются и переносятся в scriptsEvalAfterRender.evaluated.
// При каждом пришествии модели с HTML-разметкой с сервера скрипты из этой разметки заносятся в scriptsEvalAfterRender.pending, только если таких же скриптов нет в scriptsEvalAfterRender.evaluated.


window.WebAccess.components.CardTabMainTab = class {

  /**
   * Создаёт объект закладки "Карточка" в карточке объекта.
   *
   * @param {object} content Модель HTML-содержимого закладки "Карточка".
   * @param {string} content.main HTML-содержимое контейнера с формой карточки и областью переписки.
   * @param {string} content.aside HTML-содержимое контейнера с областью вложений.
   * @param {number} type Тип закладки карточки.
   */
  constructor(content, type) {
    this.type = type;
    // Селектор содержимого.
    const containerSelector = 'form.master';
    this.scriptsEvalAfterRender = [
      'InitContentListToolbox();', // TODO: для уведомления это не нужно, надо как-то различать
      'window.InitAttachmentsResize();',
    ];
    this.scriptsAlwaysEvalAfterRender = [
      () => {
        // ToDo: поле ввода текста показывается не сразу, поэтому запускаем по таймауту.
        setTimeout(window.InitSavedTextResize, 0);
      },
      window.ShowOnlyCurrentRelatedTasks,
      window.ScrollTreeToCurrentJob,
      () => {
        $('.TaskTree').removeClass('TaskTree__hidden');
      },
      () => window.InitTooltips(),
      () => {
        const jAttachments = $('#Attachments_AttachmentsList_list');
        EntityListInit(jAttachments, true, false);

        // Остановим всплытие события к родительскому элементу - списку объектов, 
        // т.к. по факту изменение списка не происходит.
        $('#Attachments_AttachmentsList_chkAll').bind('change', event => event.stopPropagation());

        // Сформировать список вложений. Почему сделано на jQuery:
        // Если присылать список вложений с бэка, то список заморозится до переключения вкладки, т.к.
        // функция инициализации CardTabMainTab отрабатывает только при переключении и обновлении вкладок.
        const jAttachmentItems = jAttachments.find('.object-list-item');
        const values = jAttachmentItems.toArray().map(attachmentItemNode => {
          const jAttachmentItem = $(attachmentItemNode);
          return {
            CompCode: jAttachmentItem.attr('compcode'),
            ID: jAttachmentItem.attr('id'),
            Kind: jAttachmentItem.attr('kind'),
          };
        });

        ListRequisite("Attachments_AttachmentsList").Init({
          ContentKind: "ANY",
          Values: JSON.stringify(values),
          OnLoad: "this.InitAttachments(WA.CR.ID, WA.CR.Type === OBJECT_TYPE.TASK ? 'TASK' : 'JOB');",
          ReadOnly: $('#Attachments_AttachmentsList_OuterPanel').hasClass('readonly'),
          IsList: true,
          ShowScrollBar: true,
          EnableSameRecords: true,
          NeedShowPasteAndDeleteLink: true,
          IsShowActions: false,
          RefCode: null
        });
        window.UpdateCopyPasteIcons(jAttachments);
      },
    ];
    switch (this.type) {
      case TAB_TYPE.TASK_CARD:
        this.scriptsAlwaysEvalAfterRender.push(...[
          () => {
            Core.tasks.initSelectStandardRouteButton();
            Core.customWorks.bindButtonsEnabling('textarea.Card_Task_EditText');
            Core.customWorks.bindButtonsEnabling('input#CardContrrolSubject');
            WA.CR.objectList = new WebAccess.components.wrappers.objectList.FolderList(containerSelector);
            new Core.objectList.dragging().initEvents();
          },
        ]);
        this.scriptsEvalAfterRender.push(...[
          'Task_SetFocusToEditText()',
        ]);
        break;
      case TAB_TYPE.JOB_CARD:
        this.scriptsAlwaysEvalAfterRender.push(...[
          () => {
            Core.customWorks.bindButtonsEnabling('textarea.Job_Edit_Text_Area_Control');
            WA.CR.objectList = new WebAccess.components.wrappers.objectList.FolderList(containerSelector);
            new Core.objectList.dragging().initEvents();
          },
        ]);
        this.scriptsEvalAfterRender.push(...[
          'Job_SetFocusToEditText()',
        ]);
    }
    this.updateModel(content);

    // Байндим проверку на пользовательские изменения при попытке закрытия окна или переключения вкладки
    WA.CR.window.bind('beforeClose', () => {
      if (this.isModifiedByUser()) {
        return L('DATA_DIDNT_SAVE');
      }
      return false;
    });
    $('html').bind(PAGE_EVENTS.ON_BEFORE_TAB_CHANGE, (event) => {
      event.currentTarget.isModifiedByUser = this.isModifiedByUser();
    });
    $(window).off('resize.tab').on('resize.tab', () => {
      window.InitSavedTextResize();
    });
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Обновляет закладку "Карточка", скрипты, сериализует поля формы.
   * @method WebAccess.components.CardTabMainTab#updateModel
   * @param {object} content Модель HTML-содержимого закладки «Карточка».
   * @param {string} content.main HTML-содержимое контейнера с формой карточки и областью переписки.
   * @param {string} content.aside HTML-содержимое контейнера с областью вложений.
   */
  updateModel(content) {
    this.contentJustReceivedFromServer = true;

    // Декодировать html, получить инициализационные скрипты и удалить их из разметки
    this.content = {
      main: this._extractScriptsFromHtml(content.main)
      // Заменить форму на div, чтобы не было проблем при отправке формы на сервер
        .replace('<form ', '<div ')
        .replace('form>', 'div>'),
      aside: this._extractScriptsFromHtml(content.aside),
    };

    this.serializedTabData = this._serializeCardForm(this.content.main) + this._serializeAttachments(this.content.aside);
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Получает модель HTML-содержимого закладки «Карточка».
   * @method WebAccess.components.CardTabMainTab#getContent
   * @returns {object} Модель HTML-содержимого закладки «Карточка».
   */
  getContent() {
    return this.content;
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Получает функции и атрибуты для расширения модели родительской компоненты для прокидывания в React-компоненту.
   * @comment Inna: чем можно заменить "прокидывания"? "добавления"?
   * @method WebAccess.components.CardTabMainTab#getExtendedProperties
   * @returns {object} Объект, который будет присвоен атрибуту extended родительской компоненты.
   */
  getExtendedProperties() {
    let extendedProps = {
      initCustomWork: () => {
        this._initCustomWork(this);
      },
    };
    if (this.type === TAB_TYPE.JOB_CARD) {
      extendedProps.initTooltip = (element) => {
        InitAdditionalInfoTooltip($(element));
      };
    }
    return extendedProps;
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Удалить.
   *
   * @method WebAccess.components.CardTabMainTab#unbindEvents
   */
  unbindEvents() {
    WA.CR.window.unbind('beforeClose');
    $('html')
      .unbind(PAGE_EVENTS.ON_BEFORE_TAB_CHANGE)
      .get(0).isModifiedByUser = false;
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Проверяет, была ли информация изменена пользователем.
   * @method WebAccess.components.CardTabMainTab#isModifiedByUser
   * @private
   * @returns {boolean} TRUE - если информация модифицирована пользователем, иначе - FALSE.
   */
  isModifiedByUser() {
    let currentSerializedTabData = this._serializeCardForm() + this._serializeAttachments();
    return (this.serializedTabData !== currentSerializedTabData);
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Инициализировать скрипты ЗЗУ.
   * @method WebAccess.components.CardTabMainTab#_initCustomWork
   * @private
   * @param {object} mainTab Объект CardTabMainTab.
   */
  _initCustomWork(mainTab) {
    if (mainTab.contentJustReceivedFromServer) {
      while (mainTab.scriptsEvalAfterRender.length) {
        const fn = mainTab.scriptsEvalAfterRender.shift();
        Function(fn).call();
      }

      mainTab.contentJustReceivedFromServer = false;
      for (const fn of mainTab.scriptsAlwaysEvalAfterRender) {
        fn();
      }
    }
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Сериализует данные полей формы.
   * @method WebAccess.components.CardTabMainTab#_serializeCardForm
   * @private
   * @param {string} [opt_container] Строка с html либо селектором, данные из которых будут сериализованы.
   * @returns {string} Сериализованные поля формы карточки.
   */
  _serializeCardForm(opt_container) {
    let jMain = $(opt_container || '.conversation-container');
    let jMainFormValues = jMain.find('input[type=text],input[type=checkbox],input[type=radio],select,textarea');
    let jHiddenFormValues = jMain.find('input[id^=hSelID_]').filter((i, elem) => { // TODO: может нафиг этот фильтр? и так норм поля собираются
      let dispInp = jMain.find('#' + $(elem).attr('name'));
      return !!dispInp.length;
    });
    return jMainFormValues.serialize() + '&' + jHiddenFormValues.serialize();
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Сериализует данные вложений.
   * @method WebAccess.components.CardTabMainTab#_serializeAttachments
   * @private
   * @param {string} [opt_container] Строка с html либо селектором, данные из которых будут сериализованы.
   * @returns {string} Сериализованная область вложений карточки.
   */
  _serializeAttachments(opt_container) {
    let jAttachments = $(opt_container || '.attachments_list');
    if (!jAttachments.find('#pnlEmpty').length) {
      let attachmentsData = [];
      jAttachments.find('[data-name="ObjectListItem"]').each((i, el) => {
        let jAttachment = $(el);
        let kind = jAttachment.attr('kind');
        let attachmentInfo = kind + '_' + jAttachment.attr('id');
        if (kind === 'Ref') {
          attachmentInfo += '_' + jAttachment.attr('compcode');
        }
        attachmentsData.push(attachmentInfo);
      });
      return '&attachments=' + attachmentsData.join(';');
    }
    return '';
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Вытащить скрипты из html.
   * @method WebAccess.components.CardTabMainTab#_extractScriptsFromHtml
   * @private
   * @param {string} sourceHtml Исходная строка с html.
   * @returns {string} Строка с декодированным html с вырезанными тегами <script>.
   */
  _extractScriptsFromHtml(sourceHtml) {
    // Regex для поиска скриптов, такой же используется в jQuery: https://github.com/jquery/jquery/blob/1.7.2/src/ajax.js#L14
    const regexForScriptTags = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    let resultHtml = $('<textarea/>').html(sourceHtml).text();
    let scriptTags = resultHtml.match(regexForScriptTags);
    if (!scriptTags) {
      return resultHtml;
    }
    for (let script of scriptTags) {
      this.scriptsEvalAfterRender.push($(script)
        .html() // TODO: перееписать на regex для удаления тегов script, CDATA и js-комментов одной операцией
        .replace('//<![CDATA[', '')
        .replace('//]]>', '')
      );
    }
    return resultHtml.replace(regexForScriptTags, '');
  }
};
